import cn from 'classnames';
import { ReactNode } from 'react';

import headersStyles from '@creditflowresearch/uilib/styles/headers.module.scss';

type TTag = 'h1' | 'h2' | 'h3';

interface ITitleProps {
  title: ReactNode,
  tag?: TTag,
  /** Visual size, when it has to differ from the heading level required by the document outline */
  variant?: TTag,
  className?: string,
  dataTest?: string,
}

const variantClasses: Record<TTag, string> = {
  h1: headersStyles.isH2,
  h2: headersStyles.isH2,
  h3: headersStyles.isH3,
};

const Title = ({
  title,
  tag: Tag = 'h3',
  variant = Tag,
  className,
  dataTest = 'title',
}: ITitleProps) => (
  <Tag data-test={ dataTest } className={ cn(variantClasses[variant], className) }>{ title }</Tag>
);

export default Title;
